import { render } from "./StyledTabs.vue?vue&type=template&id=552049ed"
import script from "./StyledTabs.vue?vue&type=script&lang=js"
export * from "./StyledTabs.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/tom/tom/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__